import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FullCV,
  Textarea,
} from '@cibli/shared';
import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useValidateOnMount } from '../../hooks/useValidateOnMount';
import { useVocalFormUpdate } from '../../hooks/useVocalFormUpdate';
import { createSummarySchema, SummaryFormValues } from '../../schemas/summary.schema';
import FormLayout from './FormLayout';

interface SummaryFormProps {
  onSubmit: (data: FullCV) => void;
  initialData?: FullCV;
  onCancel: () => void;
}

const SummaryForm: React.FC<SummaryFormProps> = ({ onSubmit, initialData, onCancel }) => {
  const { t } = useTranslation();

  const summarySchema = createSummarySchema(t);

  const form = useForm<SummaryFormValues>({
    resolver: zodResolver(summarySchema),
    defaultValues: {
      summary: initialData?.summary || '',
    },
  });

  const handleSubmit = (data: SummaryFormValues) => {
    onSubmit(data as FullCV);
  };

  useValidateOnMount(form);
  useVocalFormUpdate(form, 'summary');

  return (
    <FormLayout
      title={t('CV.summary')}
      onCancel={onCancel}
      onSubmit={form.handleSubmit(handleSubmit)}
      showAddButton={false}
    >
      <Form {...form}>
        <form className="space-y-6 pb-20">
          <FormField
            control={form.control}
            name="summary"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>{t('CV.summary')}</FormLabel>
                <FormControl>
                  <Textarea
                    className="min-h-[200px] resize-none"
                    placeholder={t('Forms.PersonalInfo.summaryPlaceholder')}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </form>
      </Form>
    </FormLayout>
  );
};

export default SummaryForm;
